module.exports = __webpack_public_path__ + "img/icon-blind.dd2cda6f.svg";